export default __webpack_public_path__ + "static/flag-ie-9ccd7200dfb7a07d937cc2d751e54803.svg";